module.exports = __webpack_public_path__ + "img/wallet.a114d28f.svg";